<template>
    <div v-show="show===true" class="confirm-box-for-app-modal-overlay">
        <div class="confirm-box-for-app confirmBox pc">
            <p class="confirm-box-for-app__copy">{{message}}</p>
            <p class="confirm-box-for-app__desc">{{subMessage}}</p>
            <div class="confirm-box-for-app__btnwrap">
                <button class="confirm-btn" @click="hiddenConfirm()">閉じる</button>
            </div>
        </div>
    </div>
</template>

<script>
import componentModalCenter from '../../js/modules/componentModalCenter.js'// eslint-disable-line
import componentScrollControl from '../../js/modules/componentScrollControl.js'// eslint-disable-line

export default {
    name: 'AlertForApp',
    data() {
        return {
            show: false,
        }
    },
    props:{
        message: {
            type: String
        },
        subMessage: {
            type: String
        },
        errorFlag: {
            type:Boolean
        }
    },
    methods: {
        showConfirm() {// eslint-disable-line
            if (this.show === false) {
                this.show = true;
                this.$nextTick(function () {
                    componentScrollControl.no_scroll();
                    componentModalCenter(".confirm-box-for-app");
                    document.getElementById('page_top').style.display = 'none';
                })
            }
        },
        hiddenConfirm() {
            componentScrollControl.return_scroll();
            this.show = false;
            this.$emit('confirmFinished');
            this.$nextTick(function () {
                document.getElementById('page_top').style.display = '';
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/modal/AlertForApp.css";
</style>